import { render, staticRenderFns } from "./NewSupplierInfo.vue?vue&type=template&id=5a656e90&scoped=true&"
import script from "./NewSupplierInfo.vue?vue&type=script&lang=js&"
export * from "./NewSupplierInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a656e90",
  null
  
)

export default component.exports